/**
 * Registra /sw.js (public/sw.js). Solo en producción: en `yarn start` un service worker
 * activo complica el debug y no aporta nada. Un fallo al registrar nunca debe romper la app.
 */
export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* noop: sin SW la app funciona igual, solo no hay pantalla offline */
    });
  });
}
